// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type AiFormAfpFragment = { __typename?: 'AiFieldProposal', id: string, fieldName: string, fieldValue?: string | null | undefined, parentType: Types.AiEntityProposalType, pageNumbers?: Array<number> | null | undefined, status: { __typename?: 'AiFieldProposalStatusDetail', code: Types.AiFieldProposalStatus } };

export type AiFormAepFragment = { __typename?: 'AiEntityProposal', id: string, rationalization?: string | null | undefined, type: { __typename?: 'AiEntityProposalTypeDetail', code: Types.AiEntityProposalType }, entity:
    | { __typename: 'MaterialListing', id: string }
    | { __typename: 'MaterialVariant', id: string }
    | { __typename: 'ReadyPlanLocation', id: string }
    | { __typename: 'ReadyPlanOption', id: string }
    | { __typename: 'ReadyPlanProgramData', id: string }
    | { __typename: 'TakeoffLineItem', id: string }
  , fieldProposals: Array<{ __typename?: 'AiFieldProposal', id: string, fieldName: string, fieldValue?: string | null | undefined, parentType: Types.AiEntityProposalType, pageNumbers?: Array<number> | null | undefined, status: { __typename?: 'AiFieldProposalStatusDetail', code: Types.AiFieldProposalStatus } }> };

export const AiFormAfpFragmentDoc = gql`
    fragment AiFormAfp on AiFieldProposal {
  id
  fieldName
  fieldValue
  status {
    code
  }
  parentType
  pageNumbers
}
    `;
export const AiFormAepFragmentDoc = gql`
    fragment AiFormAep on AiEntityProposal {
  id
  type {
    code
  }
  entity {
    __typename
    ... on Entity {
      id
    }
  }
  fieldProposals {
    ...AiFormAfp
  }
  rationalization
}
    ${AiFormAfpFragmentDoc}`;